import { render, staticRenderFns } from "./PersonalCerficateItem.vue?vue&type=template&id=1192c6e6&scoped=true&"
import script from "./PersonalCerficateItem.vue?vue&type=script&lang=js&"
export * from "./PersonalCerficateItem.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCerficateItem.vue?vue&type=style&index=0&id=1192c6e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1192c6e6",
  null
  
)

export default component.exports